var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$device.mobile)?_c('el-card',[_c('page-contact')],1):_c('section',{staticClass:"section"},[_c('page-contact')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }